import Cookie from 'js-cookie'

import { MessageFlash } from '#/global/helper/MessageFlash'

// Config interface
export interface DekConfig {
    api: {
        base: string
        search: string
    }
    branchCode: string | null
    branchTitle: string
    cdn: {
        base: string
    }
    companyName: string
    email: string
    hasDeksmart: boolean
    isDev: boolean
    phone: {
        full: string
        number: string
        prefix: string
    }
    shopId: string
}

// Cache config
let config: DekConfig | undefined

// Load config from cookie
const getConfig = () => {
    if (!config) {
        const configCookie = Cookie.get('dek_config')
        if (configCookie === undefined) {
            throw new Error('Config not found')
        }
        try {
            const json = atob(configCookie)
            config = JSON.parse(json) as DekConfig
        } catch (error) {
            console.error(error)
            MessageFlash.add({ type: 'error', message: 'Nepodařilo se načíst dek_config.' })
            throw new Error('Config is not valid')
        }
    }
    return config
}

// Getters
const getBaseCdn = () => getConfig().cdn.base
const getCompanyName = () => getConfig().companyName
const getBranchCode = () => getConfig().branchCode
const getBranchTitle = () => getConfig().branchTitle
const getShopId = () => getConfig().shopId
const getEmail = () => getConfig().email
const isDevelopment = () => getConfig().isDev
const getPhonePrefix = () => getConfig().phone.prefix
const getPhoneNumber = () => getConfig().phone.number
const getPhoneNumberFull = () => getConfig().phone.full
const getSearchCompany = () => getShopId().replace('_', '-')
const getCurrency = () => getLang() === 'sk' ? 'EUR' : 'CZK'
const getLang = () => {
    const shopId = getShopId()
    switch (shopId) {
        case 'argos_cz':
        case 'dek_cz':
        case 'stachema_cz':
            return 'cz'
        case 'dek_sk':
        case 'stachema_sk':
            return 'sk'
        default:
            console.warn(`Unknown shop id ${shopId}`)
            return 'cz'
    }
}
const getDomain = () => {
    const shopId = getShopId()
    switch (shopId) {
        case 'argos_cz':
            return 'argos.cz'
        case 'dek_cz':
            return 'dek.cz'
        case 'dek_sk':
            return 'dek.sk'
        case 'stachema_cz':
            return 'stachema.cz'
        case 'stachema_sk':
            return 'stachema.sk'
        default:
            console.warn(`Unknown shop id ${shopId}`)
            return 'dek.cz'
    }
}
const hasRental = () => ['dek_cz', 'dek_sk'].includes(getShopId())
const isLoggedIn = () => {
    return document.querySelector('body')?.getAttribute('data-js-loggedin') === 'true'
}
const hasDeksmart = () => getConfig().hasDeksmart

// Exported config
export const Config = {
    getBaseCdn,
    getCompanyName,
    getBranchCode,
    getBranchTitle,
    getCurrency,
    getDomain,
    getEmail,
    getLang,
    getSearchCompany,
    getShopId,
    /**
     * @deprecated use isDevelopment
     */
    isDev: isDevelopment,
    isDevelopment,
    hasRental,
    isLoggedIn,
    getPhonePrefix,
    getPhoneNumber,
    getPhoneNumberFull,
    hasDeksmart,
}
